import React from "react";
import PropTypes from "prop-types";
import GatsbyImageWithSVGSupport from "./GatsbyImageWithSVGSupport";
import { Button, Col, Row } from "react-bootstrap";
import { Link } from "gatsby";

import RichTextBlock from "./RichTextBlock";

import "../styles/components/RedirectCards.scss";

const RedirectCards = ({ cards }) => (
    <Row>
        {cards.map(card => {
            const linkProps = {
                variant: "link",
                as: Link,
                to: card.link,
            };

            if (!card.link?.startsWith("/")) {
                linkProps.as = "a";
                linkProps.href = card.link;
            }

            return (
                <Col className="my-3 my-md-0" key={card.id} md={6}>
                    <div className="redirect-card p-3 p-md-5">
                        <GatsbyImageWithSVGSupport
                            image={card.image}
                            className="bg-image"
                        />
                        <Row className="mb-2 text-center text-md-start align-items-center">
                            <Col md={3}>
                                <GatsbyImageWithSVGSupport
                                    className="card-icon me-2"
                                    image={card.icon}
                                />
                            </Col>
                            <Col>
                                <RichTextBlock content={card.copy} />
                            </Col>
                        </Row>
                        <Button {...linkProps}>{card.linkText}</Button>
                    </div>
                </Col>
            );
        })}
    </Row>
);

RedirectCards.propTypes = {
    cards: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.string.isRequired,
            copy: PropTypes.shape({ raw: PropTypes.string }).isRequired,
            image: PropTypes.shape({ gatsbyImageData: PropTypes.object })
                .isRequired,
            icon: PropTypes.shape({ gatsbyImageData: PropTypes.object })
                .isRequired,
            link: PropTypes.string.isRequired,
            linkText: PropTypes.string.isRequired,
        })
    ),
};

export default RedirectCards;
